module.exports = __webpack_public_path__ + "img/knsu_main2.1db82a3a.jpg";